import React, { FC } from 'react';

import { BasketItemWithGenericProps } from './BasketItemWithGenericProps';
import {
  isLastOfCurrentPromo,
  isNextSetShoppingBagProduct,
  isSetShoppingBagProduct,
} from './helpers';
import { ProductsInformation } from './types';
import { UpsellBundleInformation } from './UpsellBundleInformation';

interface NewShoppingBagBasketItemListRenderers {
  productsList: ProductsInformation[];
  isLastInGroups: boolean;
}

export const ShoppingBagNewItemListRenderer: FC<
  NewShoppingBagBasketItemListRenderers
> = ({ productsList, isLastInGroups }) => {
  return (
    <>
      {productsList.map(({ discounts, product }, index) => (
        <>
          <BasketItemWithGenericProps
            shouldRenderDividerBefore={
              isSetShoppingBagProduct(product) && index !== 0
            }
            shouldRenderDividerAfter={
              isSetShoppingBagProduct(product) &&
              !isNextSetShoppingBagProduct(productsList, index)
            }
            key={product.productId}
            product={product}
            discounts={discounts}
            isLastToRender={isLastInGroups && index === productsList.length - 1}
          />
        </>
      ))}
    </>
  );
};
export const ShoppingBagBundleEligibleItemListRenderer: FC<
  NewShoppingBagBasketItemListRenderers
> = ({ productsList, isLastInGroups }) => {
  return (
    <>
      {productsList.map(({ discounts, product, upsellInformation }, index) => (
        <>
          <BasketItemWithGenericProps
            shouldRenderDividerBefore={
              isSetShoppingBagProduct(product) && index !== 0
            }
            shouldRenderDividerAfter={
              isSetShoppingBagProduct(product) &&
              !isNextSetShoppingBagProduct(productsList, index)
            }
            key={product.productId}
            product={product}
            discounts={discounts}
            isLastToRender={isLastInGroups && index === productsList.length - 1}
          />
          <UpsellBundleInformation
            upsellInformation={upsellInformation}
            shouldRender={isLastOfCurrentPromo(productsList, index)}
          />
        </>
      ))}
    </>
  );
};
export const ShoppingBagGeneralItemListRenderer: FC<
  NewShoppingBagBasketItemListRenderers
> = ({ productsList, isLastInGroups }) => {
  // verify that sorted properly, with newest first
  return (
    <>
      {productsList.map(({ discounts, product }, index) => (
        <BasketItemWithGenericProps
          shouldRenderDividerBefore={
            isSetShoppingBagProduct(product) && index !== 0
          }
          shouldRenderDividerAfter={
            isSetShoppingBagProduct(product) &&
            !isNextSetShoppingBagProduct(productsList, index)
          }
          key={product.productId}
          product={product}
          discounts={discounts}
          isLastToRender={isLastInGroups && index === productsList.length - 1}
        />
      ))}
    </>
  );
};
